import { render, staticRenderFns } from "./tsm-sales.vue?vue&type=template&id=3884bfb9&scoped=true"
import script from "./tsm-sales.vue?vue&type=script&lang=js"
export * from "./tsm-sales.vue?vue&type=script&lang=js"
import style0 from "./tsm-sales.vue?vue&type=style&index=0&id=3884bfb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884bfb9",
  null
  
)

export default component.exports